// extracted by mini-css-extract-plugin
export default {"Pagehead":"YourSponsorships-module__Pagehead--h9df8"};